import React from 'react'
import PropTypes from 'prop-types'
import { cva } from 'class-variance-authority'
import { cn } from '~/lib/utils'
import { Stack } from '../../_layouts'

const badgeVariants = cva(
  'inline-flex items-center px-2 py-0.5 rounded-sm text-xs font-medium',
  {
    variants: {
      variant: {
        primary: 'bg-intoo-blue-medium-200 text-intoo-blue-medium-700',
        secondary: 'bg-intoo-green-medium-200 text-intoo-green-medium-700',
        neutral: 'bg-cod-gray-200 text-cod-gray-700',
        success:
          'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300',
        warning:
          'bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300',
        danger: 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  },
)

const Badge = ({
  children,
  variant = 'neutral',
  className = '',
  startIcon,
  endIcon,
}) => {
  return (
    <span className={cn(badgeVariants({ variant }), className)}>
      <Stack direction="row" spacing={1}>
        {!!startIcon && React.cloneElement(startIcon, { className: 'h-4 w-4' })}
        {children}
        {!!endIcon && React.cloneElement(endIcon, { className: 'h-4 w-4' })}
      </Stack>
    </span>
  )
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'neutral',
    'danger',
    'warning',
    'success',
  ]),
  className: PropTypes.string,
  startIcon: PropTypes.element,
  endIcon: PropTypes.element,
}

export default Badge
